module.exports = {"id":"215466","name":"Nikola Maksimović","rating":"78","photo":"./data/images/photos/2/215466.png","club":{"name":"Spartak Moscou","logo":"./data/images/clubs/SpartakMoscou.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NikolaMaksimovic0.json
// module id = 3225
// module chunks = 0